import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import TabLayout from '../../../../components/TabLayout';
import { Dialog, Stack, Typography, IconButton, Tabs, Tab, Box, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import EditIcon from '@mui/icons-material/Edit';
import Transition from '../../../../components/Transition';
import { useState } from 'react';
import TraderDetails from './TraderDetails';
import appapi from '../../../../api/apiClient';
import EditTraderDialog from './EditTraderDialog';
import CompanyList from './CompanyList';
import ActivityLog from '../../../../components/ActivityLog';
import { CancelToken } from 'apisauce';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '560px',
    height: '100%',
    borderRadius: '4px',
    maxWidth: '736px',
    maxHeight: 'calc(100%)',
    // overflow: 'hidden'
  },
};

export default function ViewTrader({ modelOpen, onModelHandleClose, traderId, refresh }) {
  const [openEditTrader, setOpenEditTrader] = useState(false);
  const [tabIndexValue, setValue] = React.useState(0);
  const [traderDetails, setTraderDetails] = useState([]);
  const [refreshData, setRefreshData] = useState(false);
  const [loading, setLoading] = useState(false);

  let source = CancelToken.source();

  const getTraderDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(`trader/details/${traderId}`, {},{
      cancelToken: source.token
    });
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setTraderDetails({...data?.response, contacts: data?.response?.contacts.map(item => {
          return {...item, phone: (item.phoneCode || '')+(item.contactNumber || '-')}
        })});
      }
      setLoading(false);
    } else {
      // setLoading(false);
    }
  };

  useEffect(() => {
    getTraderDetails();
    return () => {
      if(source) {
        source.cancel();
      }
    }
  }, []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
      // TransitionComponent={Transition}
      PaperProps={{ sx: { position: 'fixed', top: 0, right: 0, m: 0 } }}
    >
      <Stack
        className="!h-[100%]"
        style={{ backgroundColor: '#FFFFFF' }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="sticky top-[0] !bg-[#ffffff] z-[9] h-[56px]"
          style={{ paddingLeft: '24px', paddingRight: '24px', borderBottomWidth: 1, borderBottomColor: '#0000000D' }}
        >
          <Tabs
            indicatorColor="primary"
            value={tabIndexValue}
            onChange={handleChange}
          >
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="TRADER DETAILS"
              {...a11yProps(0)}
            />
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="COMPANY LIST"
              {...a11yProps(1)}
            />
            <Tab
              className="!capitalize !text-#14285A fw-medium ff-Roboto fs-16"
              label="ACTIVITY LOG"
              {...a11yProps(2)}
            />
          </Tabs>
          <div>
            {tabIndexValue === 0 && (
              <>
                <Tooltip
                  disableInteractive
                  title="Edit Trader"
                >
                  <IconButton onClick={() => setOpenEditTrader(true)}>
                    <EditIcon style={{ transform: 'scale(1.143)', color: '#061D30', width: '18px', height: '18px' }} />
                  </IconButton>
                </Tooltip>
              </>
            )}

            <Tooltip
              disableInteractive
              title="Close"
            >
              <IconButton onClick={() => onModelHandleClose(refreshData)}>
                <ClearIcon style={{ transform: 'scale(1.143)', color: '#061D30', width: '22px', height: '22px' }} />
              </IconButton>
            </Tooltip>
          </div>
        </Stack>
        <TabLayout>
          <TabPanel
            className="!p-[0px]"
            value={tabIndexValue}
            index={0}
          >
            {tabIndexValue === 0 ? (
              <TraderDetails
                isLoading={loading}
                details={traderDetails}
                refresh={() => {
                  setRefreshData(true);
                  getTraderDetails();
                }}
              />
            ) : null}
          </TabPanel>
          <TabPanel
            value={tabIndexValue}
            index={1}
          >
            {tabIndexValue === 1 ? <CompanyList traderId={traderId} /> : null}
          </TabPanel>

          <TabPanel
            value={tabIndexValue}
            index={2}
          >
            {tabIndexValue === 2 ? <ActivityLog type={'Trader'} refId={traderId} /> : null}
          </TabPanel>
        </TabLayout>
      </Stack>
      {openEditTrader ? (
        <EditTraderDialog
          trader={traderDetails}
          onModelHandleClose={(event) => {
            if (event) {
              setRefreshData(true);
              getTraderDetails();
            }
            setOpenEditTrader(false);
          }}
          modelOpen={openEditTrader}
        />
      ) : null}
    </Dialog>
  );
}
